/* EUROWATCH OC watch glossary. Generated - do not hand-edit.
   Queries the whole document because entries are split across sections. */
(function(){
  var root = document;
  if(!document.getElementById('ewg-search')) return;
  var input   = document.getElementById('ewg-search');
  var clear   = document.getElementById('ewg-clear');
  var count   = document.getElementById('ewg-count');
  var empty   = document.getElementById('ewg-empty');
  var emptyQ  = document.getElementById('ewg-empty-q');
  var reset   = document.getElementById('ewg-reset');
  var azbar   = document.getElementById('ewg-az-bar');
  var catidx  = document.getElementById('ewg-catindex');
  var entries = [].slice.call(root.querySelectorAll('.ewg-entry'));
  var groups  = [].slice.call(root.querySelectorAll('.ewg-group'));
  var chips   = [].slice.call(root.querySelectorAll('.ewg-chip'));
  var total   = entries.length;
  var cat = 'all', q = '';

  function strip(s){
    return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  }


  // ---- search-term highlighting ----------------------------------------
  // foldChar keeps a 1:1 character mapping so match indexes stay valid on the
  // ORIGINAL string. A plain NFD strip changes length and breaks the offsets.
  var HL_FIELDS = '.ewg-term, .ewg-meta, .ewg-def, .ewg-note p';
  var HL_MAX = 120;          // skip highlighting on very broad queries
  var hlDirty = [];          // entries currently carrying <mark>

  function foldChar(c){
    var d = c.normalize ? c.normalize('NFD') : c;
    return d.charAt(0).toLowerCase();
  }
  function foldKeep(str){
    var out = '';
    for(var i=0;i<str.length;i++) out += foldChar(str.charAt(i));
    return out;
  }
  function clearHl(el){
    var marks = el.querySelectorAll('mark.ewg-hl');
    for(var i=0;i<marks.length;i++){
      var m = marks[i];
      m.parentNode.replaceChild(document.createTextNode(m.textContent), m);
    }
    if(marks.length) el.normalize();
  }
  function clearAllHl(){
    for(var i=0;i<hlDirty.length;i++) clearHl(hlDirty[i]);
    hlDirty = [];
  }
  function markNode(node, terms){
    var text = node.nodeValue;
    var hay  = foldKeep(text);
    var hits = [];
    for(var t=0;t<terms.length;t++){
      var needle = terms[t], from = 0, at;
      while((at = hay.indexOf(needle, from)) !== -1){
        hits.push([at, at + needle.length]);
        from = at + needle.length;
      }
    }
    if(!hits.length) return false;
    hits.sort(function(a,b){ return a[0]-b[0]; });
    var merged = [hits[0]];
    for(var h=1;h<hits.length;h++){
      var last = merged[merged.length-1];
      if(hits[h][0] <= last[1]) last[1] = Math.max(last[1], hits[h][1]);
      else merged.push(hits[h]);
    }
    var frag = document.createDocumentFragment(), pos = 0;
    for(var k=0;k<merged.length;k++){
      var a = merged[k][0], b = merged[k][1];
      if(a > pos) frag.appendChild(document.createTextNode(text.slice(pos, a)));
      var mk = document.createElement('mark');
      mk.className = 'ewg-hl';
      mk.appendChild(document.createTextNode(text.slice(a, b)));
      frag.appendChild(mk);
      pos = b;
    }
    if(pos < text.length) frag.appendChild(document.createTextNode(text.slice(pos)));
    node.parentNode.replaceChild(frag, node);
    return true;
  }
  function highlight(entry, terms){
    var fields = entry.querySelectorAll(HL_FIELDS), touched = false;
    for(var f=0;f<fields.length;f++){
      var walker = document.createTreeWalker(fields[f], NodeFilter.SHOW_TEXT, null, false);
      var nodes = [], n;
      while((n = walker.nextNode())) if(n.nodeValue && n.nodeValue.trim()) nodes.push(n);
      for(var i=0;i<nodes.length;i++) if(markNode(nodes[i], terms)) touched = true;
    }
    if(touched) hlDirty.push(entry);
  }

  function apply(){
    var shown = 0;
    var terms = q ? strip(q).split(/\s+/).filter(Boolean) : [];
    var visible = [];
    clearAllHl();
    entries.forEach(function(el){
      var okCat = (cat === 'all') || (el.getAttribute('data-cat') === cat);
      var hay = el.getAttribute('data-search');
      var okQ = true;
      for(var i=0;i<terms.length;i++){
        if(hay.indexOf(terms[i]) === -1){ okQ = false; break; }
      }
      var show = okCat && okQ;
      el.classList.toggle('ewg-hide', !show);
      if(show){ shown++; visible.push(el); }
    });
    if(terms.length && shown && shown <= HL_MAX){
      var hlTerms = [];
      for(var ti=0; ti<terms.length; ti++)
        if(terms[ti].length >= 2) hlTerms.push(foldKeep(terms[ti]));
      if(hlTerms.length)
        for(var vi=0; vi<visible.length; vi++) highlight(visible[vi], hlTerms);
    }
    groups.forEach(function(g){
      var any = g.querySelector('.ewg-entry:not(.ewg-hide)');
      g.classList.toggle('ewg-hide', !any);
    });
    var filtering = (q !== '' || cat !== 'all');
    azbar.classList.toggle('ewg-hide', filtering);
    if(stickyAz) stickyAz.classList.toggle('ewg-hide', filtering);
    catidx.classList.toggle('ewg-hide', filtering);
    empty.style.display = (shown === 0) ? 'block' : 'none';
    if(shown === 0 && q) emptyQ.textContent = '"' + q + '"';
    count.innerHTML = 'Showing <b>' + shown + '</b> of ' + total + ' terms'
      + (cat === 'all' ? '' : ' in ' + cat);
    clear.style.display = q ? 'block' : 'none';
  }

  // ---- sticky A-Z bar, desktop only ------------------------------------
  // The A-Z bar lives in section 1 while the terms live in sections 2-8, so
  // position:sticky cannot span them. A fixed clone is the only way.
  var stickyAz = null;
  if(azbar && window.matchMedia && window.matchMedia('(min-width: 900px)').matches){
    stickyAz = document.createElement('div');
    stickyAz.id = 'ewg-az-sticky';
    stickyAz.innerHTML = azbar.innerHTML;
    document.body.appendChild(stickyAz);
    var cta = document.getElementById('ewg-cta');
    var onScroll = function(){
      var past  = azbar.getBoundingClientRect().bottom < 0;
      var above = cta ? cta.getBoundingClientRect().top > 220 : true;
      stickyAz.classList.toggle('ewg-az-show', past && above);
    };
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll, { passive:true });
    onScroll();
  }

  var t;
  input.addEventListener('input', function(){
    clearTimeout(t);
    t = setTimeout(function(){ q = input.value.trim(); apply(); }, 120);
  });
  clear.addEventListener('click', function(){
    input.value = ''; q = ''; apply(); input.focus();
  });
  reset.addEventListener('click', function(e){
    e.preventDefault();
    input.value=''; q=''; cat='all';
    chips.forEach(function(c){ c.classList.toggle('ewg-chip-on', c.getAttribute('data-cat')==='all'); });
    apply();
    var top=document.querySelector('#ewg-search-wrap'); if(top) top.scrollIntoView({behavior:'smooth'});
  });
  chips.forEach(function(c){
    c.addEventListener('click', function(){
      cat = c.getAttribute('data-cat');
      chips.forEach(function(x){ x.classList.remove('ewg-chip-on'); });
      c.classList.add('ewg-chip-on');
      apply();
    });
  });
  root.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href^="#term-"]');
    if(!a) return;
    if(q !== '' || cat !== 'all'){
      input.value=''; q=''; cat='all';
      chips.forEach(function(x){ x.classList.toggle('ewg-chip-on', x.getAttribute('data-cat')==='all'); });
      apply();
    }
  });
})();
